import { z } from 'zod';

export const afcSearchFilterItemSchema = z.object({
  id: z.union([
    z.string(),
    z.object({
      start: z.number(),
      end: z.number().nullish(),
    }),
  ]),
  name: z.string(),
});

export const afcSearchFiltersSchema = z.object({
  addressCountryCode: z.array(afcSearchFilterItemSchema),
  businessTitles: z.array(afcSearchFilterItemSchema),
  availabilityStatuses: z.array(z.string()),
  barredLocations: z.array(afcSearchFilterItemSchema),
  industries: z.array(afcSearchFilterItemSchema),
  primaryFocusAreas: z.array(afcSearchFilterItemSchema),
  primaryPracticeAreas: z.array(afcSearchFilterItemSchema),
  state: z.array(afcSearchFilterItemSchema),
  yearsOfExperience: z.array(afcSearchFilterItemSchema),
});
export type AfcSearchFilterItem = z.infer<typeof afcSearchFilterItemSchema>;
export type AfcSearchFilters = z.infer<typeof afcSearchFiltersSchema>;
